import { Supplier } from '@/core/domain/people/Suppliers/Suppliers.types';
import useValidateRoutes from '@/hooks/useValidateRoutes';
import { RouteType } from '@/types/RouteType';

export default function supplierValidationTabs(
  route: RouteType,
  supplier?: Supplier | null,
) {
  const routeValidate = useValidateRoutes({
    route: route.parent,
    validation: !supplier?.matrixId,
    keys: ['returnedItems', 'supplierCredit'],
  });

  return routeValidate;
}
